<template>
  <div class="radioInputWrapper" :style="styles">
    <div class="label">{{ $t(label) }}</div>
    <ValidationProvider :rules="validation" v-slot="{ errors }" :name="name">
      <div class="inputWrapper">
        <div
          v-for="option in options"
          :key="option.name"
        >
          <label class="container" :for="option.name">
            <input
              v-model="localSelected"
              type="radio"
              :name="fieldId"
              :id="option.name"
              :value="option.value"
              checked
              :disabled="option.disabled"
            />
            <span class="checkmark"></span>
            {{ $t(option.text) }}</label>
        </div>
      </div>
      <div class="validation-error text-center" style="margin-left: 5px;" v-if="errors.length">
        <img class="error_min" src="../../assets/icons/form/error.svg" alt="error" />
        {{ $t(`validation.${validation}`) }}
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: "radio-input",
  data () {
    return {
      localSelected: this.selectedValue || ""
    };
  },
  props: {
    field: {
      required: false,
      type: Array,
      default: () => []
    },
    id: {
      required: false,
      type: String,
      default: ''
    },
    name: {
      required: false,
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      required: true
    },
    fieldId: {
      type: String,
      required: true
    },
    selectedValue: {
      type: String,
      required: false,
      default: ""
    },
    validation: {
      type: String,
      required: false
    },
    direction: {
      type: String,
      required: false,
      default: "row"
    },
    color: {
      type: String,
      default: "#000"
    },
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    ...mapMutations(['setSignedUp'])
  },
  watch: {
    localSelected (value) {
      this.$emit("component-updated", {
        selectedValue: value
      });
      if (this.fieldId === 'voucherCheckbox') {
        this.setSignedUp(value === 'yes' ? true : false)
      }
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
$medium: 800px;

.label {
  text-align: left;
  margin-bottom: 20px;
  font-size: 15px;
  line-height: 27px;
}

.radioInputWrapper {
  margin-bottom: 40px;
  @media only screen and (max-width: $medium) {
    margin-left: 30px;
    margin-right: 20px;
  }
  padding: 5px;
  .inputWrapper {
    display: flex;
    justify-content: flex-start;
  }
}

/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 28px;
  width: 28px;
  background-color: #eee;
  border-radius: 50%;
  border: 2px solid #DE7C00;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  // background-color: var(--brand-color-7);
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 2px;
	left: 2px;
	width: 20px;
	height: 20px;
	border-radius: 50%;
  background: linear-gradient(112.55deg, #D55D05 0%, #D76304 18.57%, #DD7200 42.87%, #E88B00 70.35%, #F9AE00 100%);

}
</style>